<template>
  <portal to="popup">
    <section class="lead-form-popup">
      <div class="form-popup-content br-12">
        <div class="lead-form-container">
          <div data-v-5ee4643a="" class="close-popup">
            <svg
              data-v-5ee4643a=""
              xmlns="http://www.w3.org/2000/svg"
              width="15.314"
              height="15.314"
              viewBox="0 0 15.314 15.314"
            >
              <g
                data-v-5ee4643a=""
                id="Group_2110"
                data-name="Group 2110"
                transform="translate(-31.343 15.657)"
              >
                <path
                  data-v-5ee4643a=""
                  id="Union_10"
                  data-name="Union 10"
                  d="M11.9,14.729,7.657,10.486,3.415,14.729A2,2,0,0,1,.586,11.9L4.829,7.657.586,3.415A2,2,0,0,1,3.415.586L7.657,4.829,11.9.586a2,2,0,0,1,2.829,2.829L10.486,7.657,14.729,11.9A2,2,0,1,1,11.9,14.729Z"
                  transform="translate(31.343 -15.657)"
                  fill="#444958"
                ></path>
              </g>
            </svg>
          </div>
          <h3 class="news-title">
            {{ $fn.tr("Fill the form and we will contact you") }}
          </h3>
          <el-form
            action
            class="lead-form flex-box column"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <div class="input-outer">
              <el-form-item
                for="name"
                class="flex-box column font-12 noto-semibold"
                prop="name"
              >
                {{ $fn.tr("Name") }}
                <el-input
                  type="text"
                  name="name"
                  :placeholder="$fn.tr('Name')"
                  v-model="ruleForm.name"
                ></el-input>
              </el-form-item>

              <el-form-item
                for="surname"
                class="flex-box column font-12 noto-semibold"
                prop="surname"
              >
                {{ $fn.tr("Surname") }}
                <el-input
                  type="text"
                  name="surname"
                  :placeholder="$fn.tr('Your Surname')"
                  v-model="ruleForm.surname"
                ></el-input>
              </el-form-item>

              <el-form-item
                for="phone"
                class="flex-box column font-12 noto-semibold"
                prop="phone"
              >
                {{ $fn.tr("Contact Phone") }}
                <el-input
                  type="number"
                  name="phone"
                  :placeholder="$fn.tr('XXX XXXXXX')"
                  v-model="ruleForm.phone"
                ></el-input>
                <div class="error-msg noto-semibold font-12">
                  {{ $fn.tr("error msg") }}
                </div>
              </el-form-item>

              <el-form-item
                for="companyname"
                class="flex-box column font-12 noto-semibold"
                prop="companyname"
              >
                {{ $fn.tr("Company Name") }}
                <el-input
                  type="text"
                  name="companyname"
                  :placeholder="$fn.tr('Company Name')"
                  v-model="ruleForm.companyname"
                ></el-input>
              </el-form-item>

              <el-form-item
                for="companyid"
                class="flex-box column font-12 noto-semibold"
                prop="companyid"
              >
                {{ $fn.tr("Company ID") }}
                <el-input
                  type="text"
                  name="companyid"
                  :placeholder="$fn.tr('Company ID')"
                  v-model="ruleForm.companyid"
                ></el-input>
              </el-form-item>

              <el-form-item
                for="email"
                class="flex-box column font-12 noto-semibold error"
                prop="email"
              >
                {{ $fn.tr("Email") }}
                <el-input
                  type="email"
                  name="email"
                  :placeholder="$fn.tr('yourmail@mail.com')"
                  v-model="ruleForm.email"
                ></el-input>
              </el-form-item>
            </div>
            <p class="font-12 mt-21">
              {{
                $fn.tr(
                  "lorem ipsum dolor sit lorem ipsum dolor sit lorem ipsum dolor sit lorem ipsum dolor sit lorem ipsum dolor sit"
                )
              }}
            </p>

            <div class="lead-form-end flex-box">
              <div class="captcha">captcha</div>
              <el-button
                class="btn sub white"
                type="primary"
                @click="submitForm('ruleForm')"
                >{{ $fn.tr("Send") }}</el-button
              >
            </div>
          </el-form>
          <!-- <div class="success-msg br-12">
            <h5 class="noto-bold font-34">Thank you!</h5>
            <p class="text">
              We will contact you shortly, thanks for your feedback it means a
              lot to us. our customer service will review
            </p>
            <div class="reset-btn btn white">Reset</div>
          </div> -->
        </div>
      </div>
    </section>
  </portal>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        isShow: false
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$fn.tr("Please enter your name"),
            trigger: "blur"
          }
        ],
        surname: [
          {
            required: true,
            message: this.$fn.tr("Please enter your surname"),
            trigger: "blur"
          }
        ],
        companyname: [
          {
            required: true,
            message: this.$fn.tr("Please enter your company name"),
            trigger: "blur"
          }
        ],
        companyid: [
          {
            required: true,
            message: this.$fn.tr("Please enter your company ID"),
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: this.$fn.tr("Please enter your email") },
          {
            message: this.$fn.tr("Please enter a valid email address"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: this.$fn.tr("Please enter your phone number"),
            trigger: "blur"
          },
          {
            min: 3,
            max: 15,
            message: this.$fn.tr("Length should be 3 to 15"),
            trigger: "blur"
          },
          {
            // type: "number",
            message: this.$fn.tr("Please enter a valid phone number"),
            trigger: "blur"
          }
        ]
        // comment: [
        //   { required: true, message: this.$fn.tr("Please add your comment") },
        //   {
        //     min: 3,
        //     max: 200,
        //     message: this.$fn.tr("Length should be 3 to 200"),
        //     trigger: "blur"
        //   }
        // ]
      },
      methods: {
        submitForm(formName) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              var formContainer = document.querySelector(
                ".lead-form-container "
              );
              formContainer.classList.add("success");
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      }
    };
  }
};
</script>


<style>
.lead-form-popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(35, 39, 48, 0.6);
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  z-index: 99999;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
.form-popup-content {
  position: absolute;
  width: 530px;
  max-height: calc(100% - 40px);
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background: #fff;
  border: 2px solid #bcbec0;
  padding: 30px;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
.lead-form {
  backface-visibility: hidden;
  margin-top: 21px;
}
.lead-form-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.lead-form {
  height: 100%;
}
.lead-form-container h3 {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(50%, #bcbec0),
    color-stop(0%, rgba(255, 255, 255, 0))
  );
  background-image: -o-linear-gradient(
    left,
    #bcbec0 50%,
    rgba(255, 255, 255, 0) 0%
  );
  background-image: linear-gradient(
    to right,
    #bcbec0 50%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 22px 1px;
  background-repeat: repeat-x;
  padding-bottom: 21px;
}
.lead-form .el-input__inner,
.lead-form textarea {
  border-radius: 6px;
  padding-left: 15px;
  padding-right: 15px;
  border: 1px solid #bcbec0;
  box-shadow: none;
  margin-top: 7px;
}
.lead-form-container .el-input__inner::placeholder {
  color: #444958;
  transition: 0.3s;
}
.lead-form .el-input__inner:focus::placeholder {
  opacity: 0;
}
.lead-form-container .el-form-item.is-error .el-input__inner,
.lead-form-container .el-form-item.is-error .el-input__inner:focus,
.lead-form-container .el-form-item.is-error .el-textarea__inner,
.lead-form-container .el-form-item.is-error .el-textarea__inner:focus,
.lead-form-container .el-message-box__input input.invalid,
.lead-form-container .el-message-box__input input.invalid:focus {
  border-color: #ed1651;
  backface-visibility: hidden;
}
.lead-form-container .el-form-item__error {
  color: #ed1651;
  padding-top: 5px;
  position: relative;
  transition: 0.4s;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #0061af;
}
.lead-form-container .el-form-item__content {
  font-size: 12px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 17px;
  margin-bottom: 18px;
}
.lead-form-container .el-form-item {
  margin-bottom: 0;
}
.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary.is-active,
.el-button--primary:active,
.el-button--primary {
  border-color: transparent;
}

.unique-overview .overview-right h3 {
  font-size: 34px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  line-height: 40px;
}
.lead-form-container.success .success-msg {
  opacity: 1;
  pointer-events: all;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
	-moz-appearance: none;
  margin: 0;
}
.lead-form p {
  margin-bottom: 21px;
}
.lead-form-end {
  margin-top: auto;
}
.lead-form-end .btn {
  background: #0061af;
  min-width: 135px;
  padding: 0 20px;
  margin-left: 30px;
  align-self: flex-end;
}
.lead-form-end .btn span {
  font-size: inherit;
  font-family: inherit;
  color: inherit;
}
.lead-form-end .btn:hover {
  background: #ed1651;
  color: #fff;
}
.close-popup {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.close-popup svg path {
  transition: 0.6s;
}
.close-popup:hover svg path {
  fill: #ed1651;
}
.input-outer {
  overflow-y: auto;
  width: calc(100% + 15px);
  padding-right: 15px;
}
.input-outer::-webkit-scrollbar {
  width: 3px;
  background: #bcbec0;
}
.input-outer::-webkit-scrollbar-thumb {
  background: #444958;
}
@media (max-height: 850px) and (min-width: 768px) {
  .input-outer {
    max-height: 345px;
  }
}
@media (max-height: 680px) and (min-width: 768px) {
  .input-outer {
    max-height: 265px;
  }
}
@media (max-height: 590px) and (min-width: 768px) {
  .input-outer {
    max-height: 165px;
  }
}

@media (max-height: 800px) and (max-width: 767px) {
  .input-outer {
    max-height: 345px;
  }
}
@media (max-height: 680px) and (max-width: 767px) {
  .input-outer {
    max-height: 265px;
  }
}
@media (max-height: 590px) and (max-width: 767px) {
  .input-outer {
    max-height: 165px;
  }
}

@media (max-width: 767px) {
  .form-popup-content {
    width: calc(100% - 48px);
    height: calc(100% - 40px);
    padding: 20px;
    padding-right: 25px;
  }
  .lead-form-end {
    flex-direction: column;
    align-items: flex-start;
  }
  .lead-form-end .btn {
    align-self: flex-start;
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>